export const SESSION_REVIEW_PREFERENCES_STORAGE_KEY = 'paddiq.session-review-preferences.v1';

export type SessionReviewView = 'map' | 'traces';

export type SessionReviewPreferences = {
  reviewView: SessionReviewView;
  traceViewId: string | null;
};

type PreferenceStorage = Pick<Storage, 'getItem' | 'setItem'>;

const DEFAULT_SESSION_REVIEW_PREFERENCES: SessionReviewPreferences = {
  reviewView: 'map',
  traceViewId: null,
};

function browserStorage(): PreferenceStorage | null {
  return typeof window === 'undefined' ? null : window.localStorage;
}

export function readSessionReviewPreferences(
  storage: PreferenceStorage | null = browserStorage(),
): SessionReviewPreferences {
  if (!storage) return DEFAULT_SESSION_REVIEW_PREFERENCES;

  try {
    const value = JSON.parse(
      storage.getItem(SESSION_REVIEW_PREFERENCES_STORAGE_KEY) ?? '{}',
    ) as Partial<SessionReviewPreferences>;
    return {
      reviewView: value.reviewView === 'traces' ? 'traces' : 'map',
      traceViewId:
        typeof value.traceViewId === 'string' && value.traceViewId.trim()
          ? value.traceViewId
          : null,
    };
  } catch {
    return DEFAULT_SESSION_REVIEW_PREFERENCES;
  }
}

export function updateSessionReviewPreferences(
  patch: Partial<SessionReviewPreferences>,
  storage: PreferenceStorage | null = browserStorage(),
) {
  const current = readSessionReviewPreferences(storage);
  const next: SessionReviewPreferences = {
    reviewView: patch.reviewView === 'map' || patch.reviewView === 'traces'
      ? patch.reviewView
      : current.reviewView,
    traceViewId: patch.traceViewId === undefined
      ? current.traceViewId
      : typeof patch.traceViewId === 'string' && patch.traceViewId.trim()
        ? patch.traceViewId
        : null,
  };

  try {
    storage?.setItem(SESSION_REVIEW_PREFERENCES_STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Preferences should never prevent Session Review from loading.
  }

  return next;
}
